import { gql } from 'apollo-angular';
import { dashboardItemFragment } from '../dashboard/dashboard.fragments';

export const qualityInstrumentItemFragment = gql`
  fragment QualityInstrumentItem on QualityInstrument {
    id
    createdAt
    order
    title
    descriptionJsonContent
    descriptionTemplateJsonContent
  }
`;

export const qualityInstrumentDetailFragment = gql`
  fragment QualityInstrumentDetail on QualityInstrument {
    ...QualityInstrumentItem
    dashboard {
      ...DashboardItemFragment
    }
  }

  ${qualityInstrumentItemFragment}
  ${dashboardItemFragment}
`;
